import React, { useState,useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DataSelector.module.css';
import Button from '../../common/Button/Button'
import SecondaryButton from '../../common/Button/SecondaryButton'
import moment from 'moment';

const DataSelector = ({ onFilterChange }) => {
  useEffect(() => {
    handleSubmit();
  }, []);
  const [startDate, setStartDate] = useState(moment().subtract(8, 'days').toDate());
  const [endDate, setEndDate] = useState(moment().subtract(1, 'days').toDate());
  const [dataType, setDataType] = useState('visitors'); // selected data type
  const [location, setLocation] = useState('Casalvecchio'); // selected location
  const [locationOptions, setLocationOptions] = useState(['Casalvecchio','Limina',  'Antillo']);

  

  const handleDataTypeChange = (event) => {
    const value = event.target.value;
    setDataType(value);
    if (value === 'visitors') {
      setLocationOptions(['Casalvecchio','Limina',  'Antillo']);
      setLocation('Limina');
    } else if (value === 'flights') {
      setLocationOptions(['Catania']);
      setLocation('Catania');
    } else if (value === 'cruises') {
      setLocationOptions(['Catania','Messina']);
      setLocation('Catania');
    }
  };
  

  const handleSubmit = (event) => {
    // event.preventDefault();
    if (startDate && endDate && dataType && location) {
      const selectedValues = {
        startDate,
        endDate: moment(endDate).add(1, 'day').toDate(),
        dataType,
        location
      };
      onFilterChange(selectedValues);
    } else {
      alert('Si prega di selezionare un periodo, la tipologia di dati e la posizione desiderata');
    }
  };


  // const handleDataTypeChange = (event) => {
  //   const selectedDataType = event.target.value;
  //   setDataType(selectedDataType);
  // };

  const handleLocationChange = (event) => {
    const selectedLocation = event.target.value;
    setLocation(selectedLocation);
  };

  return (
    <div className={styles.OuterFlex}>
      <div className={styles.OuterShell}>
        <div className={styles.DatePickerShell}>
          <div className={styles.dateShell}>
            <div className={styles.Fields}>
              <label className={styles.Text}>Periodo da:</label>
              <DatePicker
                className={styles.DPfield}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <div className={styles.Fields}>
              <label className={styles.Text}>Periodo a:</label>
              <DatePicker
                className={styles.DPfield}
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
        </div>
        <div className={styles.dropSelectorOuter}>
          <div className={styles.Fields}>
            <label>Dati:</label>
            <select className={styles.select} value={dataType} onChange={handleDataTypeChange}>
              <option value="flights">voli</option>
              <option value="visitors">visitatori</option>
              <option value="cruises">crociere</option>
            </select>
          </div>
          <div className={styles.Fields}>
            <label>Posizione:</label>
            <select className={styles.select} value={location} onChange={handleLocationChange}>
              {locationOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <Button text="Anteprima" onClick={handleSubmit}></Button>
    </div>
  );
};

export default DataSelector;